import React, { useState } from 'react';
import CollapsiblePanel from '../../../../formInputsV2/CollapsiblePanel';
import { Card, AlwaysOpenAtDesktop } from './shared.styles';
import {
  EmptyState,
  TotalBar,
  TotalLabel,
  TotalAmount,
  ProcediCta,
  QuoteList,
  QuoteLineItem,
  CompanyName,
  QuoteTypeTag,
  Amount,
  EstimatedCommission,
} from './QuoteCostSummaryCard.styles';

// Travel doesn't show a top processingQuote line at all (that block is dead
// code — commented out — in the original page), and it has an extra
// per-product info block (ProductInformationEurope/Mondo, from the screen's
// own ./parts folder) that the shared QuoteCostSummaryCard has no concept
// of — so it gets its own component. `children` is where the screen slots
// that extra block in, keeping those Travel-only parts out of this shared
// v2 folder.
function TravelQuoteCostSummaryCard({
  processingQuote,
  quoteTypes,
  riskQuotations,
  getTotal,
  onProcedi,
  children,
  est_provvigioni,
}) {
  const [detailsOpen, setDetailsOpen] = useState(false);

  if (processingQuote === null) {
    return (
      <Card>
        <EmptyState>Seleziona Le Quotazioni Che Vuoi Aquistare</EmptyState>
      </Card>
    );
  }

  return (
    <Card>
      <TotalBar>
        <div>
          <TotalLabel>Totale</TotalLabel>
          <TotalAmount>
            {getTotal()}
            {' '}
            €
          </TotalAmount>
          {(est_provvigioni != null && est_provvigioni !== '' && !Number.isNaN(parseFloat(est_provvigioni))) && (
            <EstimatedCommission>
              Stima Provvigioni:
              {' '}
              {parseFloat(est_provvigioni).toFixed(2)}
              {' '}
              €
            </EstimatedCommission>
          )}
        </div>
        {onProcedi && (
          <ProcediCta type="button" onClick={onProcedi}>
            Procedi
          </ProcediCta>
        )}
      </TotalBar>

      <AlwaysOpenAtDesktop>
        <CollapsiblePanel
          open={detailsOpen}
          onToggle={() => setDetailsOpen((open) => !open)}
          instructionText=""
          openLabel="Nascondi Dettaglio"
          closedLabel="Vedi Dettaglio Quotazioni"
        >
          <QuoteList>
            {quoteTypes
              .filter((t) => t.id !== 'res_civile')
              .map((type) => (
                <React.Fragment key={type.id}>
                  {riskQuotations && riskQuotations[type.id]
                    ? riskQuotations[type.id].map((quote, i) => (
                      <QuoteLineItem key={i}>
                        <CompanyName>
                          {quote.company !== null
                            ? quote.company.name
                            : quote.preventivas_company.company_name}
                          {' '}
                          <QuoteTypeTag>
                            (
                            {
                              quoteTypes.find(
                                (item) => item.id === quote.quote_type,
                              ).name
                            }
                            )
                          </QuoteTypeTag>
                        </CompanyName>
                        <Amount>
                          {parseFloat(quote.amount).toFixed(2)}
                          {' '}
                          €
                        </Amount>
                      </QuoteLineItem>
                    ))
                    : null}
                </React.Fragment>
              ))}
            {children}
          </QuoteList>
        </CollapsiblePanel>
      </AlwaysOpenAtDesktop>
    </Card>
  );
}

export default TravelQuoteCostSummaryCard;
